module.exports = __webpack_public_path__ + "static/media/ecolab2.29bbee52.png";